import type { ReactNode } from "react";
import { createContext, useContext } from "react";

type MarkdownLinkCopy = {
  title: string;
  cancel: string;
  open: string;
};

const defaultMarkdownLinkCopy: MarkdownLinkCopy = {
  title: "Open external link?",
  cancel: "Cancel",
  open: "Open",
};

export type MarkdownInternalNavigation = {
  /** Resolve only known routes owned by the current application. */
  resolve(url: string): string | null;
  open(path: string): void;
};
const InternalNavigationContext = createContext<MarkdownInternalNavigation | null>(null);

export function useMarkdownInternalNavigation() {
  return useContext(InternalNavigationContext);
}

const CopyContext = createContext<MarkdownLinkCopy>(defaultMarkdownLinkCopy);
const OriginContext = createContext<string | null>(null);

export function MarkdownLinkPromptProvider({
  copy = defaultMarkdownLinkCopy,
  appOrigin = null,
  internalNavigation = null,
  children,
}: {
  copy?: MarkdownLinkCopy;
  appOrigin?: string | null;
  internalNavigation?: MarkdownInternalNavigation | null;
  children: ReactNode;
}) {
  return (
    <CopyContext.Provider value={copy}>
      <OriginContext.Provider value={appOrigin}>
        <InternalNavigationContext.Provider value={internalNavigation}>
          {children}
        </InternalNavigationContext.Provider>
      </OriginContext.Provider>
    </CopyContext.Provider>
  );
}

export function useMarkdownLinkCopy() {
  return useContext(CopyContext);
}

export function useMarkdownLinkAppOrigin() {
  return useContext(OriginContext);
}
